
<script>
import UnitInfo__sensors_default from "@/components/units/sensors/UnitInfo__sensors_default.vue";

const connection_type = {
    cell: "Cell",
    mcell: "Cell",
    wifi: "WiFi",
    gps: "GPS"
};
export default {
    name: "UnitInfo__sensors_connection_type",
    extends: UnitInfo__sensors_default,
    computed:{
        connectionType() {
            return this.unitLmsgSensors.connection_type
        },
        title() {
            let type = connection_type[this.connectionType?.value] || this.connectionType?.value;
            type = (this.$te('Unit.sensor.connection_type.' + type) ? this.$t('Unit.sensor.connection_type.'+ type) : type) || this.$t('Unit.sensors.Connection Type')
            return type + ' ' + this.$t('text.Accuracy')
        },
        connectionRadius() {
            return this.unitLmsgSensors.radius
        },
        value() {
            return (this.connectionRadius?.value ||  this.connectionRadius?.value == 0)  ? (this.connectionRadius?.value + 'm') : ''
        },
        icon() {
            return this.showIcon ? (this.$consts.connectionTypesIcon[this.connectionType?.value] || 'empty') : false
        }
    },
}
</script>

<style scoped>

</style>